import { Navigate } from "react-router-dom";
import { isAuthenticated } from "../../network/service/UserService";
import { canViewNutritionReviews, platformUser } from "../../network/service/PlatformAuth";
import PlatformSignInNotice from "../products/nutrition/platform-sign-in-notice";
import "../products/nutrition/nutrition-panel.css";

/**
 * Wraps the nutrition review screens. Admin staff and nutrition experts
 * both see them inside the sidebar layout (experts get a nutrition-only
 * menu); anyone signed out is sent to the nutrition expert login.
 */
function ReviewAccess({ children }) {
  const adminSession = isAuthenticated();
  const user = platformUser();

  if (!adminSession && !user) {
    return <Navigate to="/nutritionist-login" replace />;
  }

  return (
    <>
      {!user && (
        <main className="container-fluid dashboard">
          <PlatformSignInNotice />
        </main>
      )}
      {user && !canViewNutritionReviews() && (
        <main className="container-fluid dashboard">
          <div className="nutri-status nutri-status-warn">
            Your account cannot review nutrition. Ask a super admin for access.
          </div>
        </main>
      )}
      {user && canViewNutritionReviews() && children}
    </>
  );
}

export default ReviewAccess;
